import { getKitSciVersion } from '@repo/utils';
import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';
import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets';
import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';

export async function getSubMetricDetail(
  kitId: string,
  subMetricId: string,
  sciVersion: string,
) {
  const res = await API.get(
    apiName,
    `${apiBasePath}/results/sub-metric-detail/${kitId}/${subMetricId}?relativeAbundanceLimit=0.00005&sciVersion=${sciVersion}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.INSIGHTS,
        importance: IMPORTANCE.HIGH,
      },
      context: {
        kitId,
        subMetricId,
        sciVersion,
      },
    },
  );
  return res?.result;
}
export const getSubMetricDetailQuery = (
  kitId?: string,
  subMetricId?: string,
  sciVersion?: string,
) => ({
  queryKey: [apiName, `subMetricDetail`, kitId, subMetricId, sciVersion],
  queryFn: () =>
    kitId && subMetricId
      ? getSubMetricDetail(kitId, subMetricId, sciVersion ?? '')
      : undefined,
});

export const usePrefetchSubMetricDetail = (
  kitId: string,
  subMetricId: string,
  sciVersion: string,
) => {
  const queryClient = useQueryClient();
  const prefetchSubMetricDetail = async () => {
    await queryClient.prefetchQuery(
      getSubMetricDetailQuery(kitId, subMetricId, sciVersion),
    );
  };
  return prefetchSubMetricDetail;
};

const useSubMetricDetail = (subMetricId: string) => {
  const { currentKitId, currentKit } = useCurrentKitAndTinyAccount();
  const sciVersion = getKitSciVersion(currentKit);

  const insightsDataQuery = useSuspenseQuery(
    getSubMetricDetailQuery(currentKitId, subMetricId, sciVersion),
  );

  return insightsDataQuery;
};

export default useSubMetricDetail;
